// @flow

import React, { Component } from 'react';
// import { RouteTransition } from 'react-router-transition';
import Helmet from 'react-helmet';
// import DevTools from 'mobx-react-devtools';
import { observer } from 'mobx-react';
import { css } from 'glamor';

import Content from '~/components/layout/Content';
import Header from '~/components/layout/Header';
import Menu from '~/components/layout/Menu';
import FooterContainer from '~/components/layout/FooterContainer';

const WEBSITE_BASE_URL = (function() {
    if (typeof location !== 'undefined') {
        return location.href;
    }

    return process.env.NODE_ENV === 'production' ?
        'https://www.supagemu.com' :
        'http://localhost:4002';
})();

const reset = css({
    fontFamily: 'Lato, Helvetica Neue, Helvetica, Arial, sans-serif',
    fontWeight: 300,
});

@observer
export default class App extends Component {
    props: {
        children: any,
    };

    render() {
        return (
            <div { ...reset }>
                <Helmet
                    htmlAttributes={{ lang: 'en', amp: undefined }}
                    title="Home"
                    titleTemplate="supagemu - %s"
                    defaultTitle="Home of retro gaming"
                    base={{ target: '_blank', href: WEBSITE_BASE_URL }}
                    meta={ [
                        {
                            name: 'description',
                            content: 'Retro gaming reviews',
                        },
                        {
                            property: 'fb:app_id',
                            content: '1631516087142982',
                        },
                        {
                            property: 'og:url',
                            content: WEBSITE_BASE_URL,
                        },
                        {
                            property: 'og:type',
                            content: 'website',
                        },
                        {
                            property: 'og:title',
                            content: 'supagemu.com',
                        },
                        {
                            property: 'og:description',
                            content: 'Retro gaming reviews: Super Famicom, PC Engine, Mega Drive, Neo Geo, Famicom... ',
                        },
                        {
                            property: 'og:image',
                            content: `${WEBSITE_BASE_URL}/assets/images/supagemuog.png`,
                        },
                        {
                            property: 'og:image:width',
                            content: '610',
                        },
                        {
                            property: 'og:image:height',
                            content: '282',
                        },
                    ] }
                    // link={ [
                    // {'rel': 'apple-touch-icon',
                    // 'href': 'http://mysite.com/img/apple-touch-icon-57x57.png'},
                    // {'rel': 'apple-touch-icon', 'sizes': '72x72',
                    // 'href': 'http://mysite.com/img/apple-touch-icon-72x72.png'}
                    // ] }
                />
                {/* <DevTools position={{ bottom: 0, left: 46 }} /> */}
                <Header />
                <Menu />
                {/*<RouteTransition
                        pathname={ this.props.location.pathname }
                        atEnter={{ opacity: 0 }}
                        atLeave={{ opacity: 2 }}
                        atActive={{ opacity: 1 }}
                        mapStyles={ styles => {
                            if (styles.opacity > 1) {
                                return { display: 'none' }
                            }

                            return { opacity: styles.opacity }
                        }}
                >*/}
                <Content>
                    {this.props.children}
                </Content>
                {/*</RouteTransition>*/}
                <FooterContainer />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/App.js